import { useEffect, useState } from "react";
import { saveConfiguration } from "@/lib/dynamo";

export function useSaveConfiguration(modelName: string, options: string[]) {
  const [code, setCode] = useState<string>();

  const save = async () => {
    const data = await saveConfiguration(modelName, options);
    if (!data) throw new Error("Failed to save configuration");
    setCode(data.code);
    return data.code;
  };

  return {
    code,
    save,
  };
}
